import ProductAdvancedSelector from './product-advanced-selector.vue'

ProductAdvancedSelector.install = function (Vue) {
	Vue.component(ProductAdvancedSelector.name, ProductAdvancedSelector);
}

export default ProductAdvancedSelector;